.container {
    position: relative;
    display: flex;
    flex-direction: column;
    user-select: none;
}

.error-image-container {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    top: 53px;
    left: 0;
}

.error-image {
    height: 120px;
}

.error-text {
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;
    bottom: -50px;
    font-size: var(--font-normal);
}

.empty-row {
    height: 88px;
}
.empty-row:nth-child(2n) {
    background-color: var(--zebra-stripe);
}
